export const baseUrl = 'https://bcms-functions.web.app/Patient/healthline/v1'
//export const baseUrl = 'https://bcms-functions-dev.web.app/Dev/healthline/v1'
// export const baseUrl = 'https://us-central1-bcms-covid-check.cloudfunctions.net/covidappdev/dev/healthline/v1'


